package com.macrofocus.nastac.ui.layer

import com.macrofocus.nastac.data.HEG
import deckgl.DataFilterExtension
import deckgl.MVTLayer
import js.objects.unsafeJso

fun createHEGLayer(visible: Boolean, year: Int) : MVTLayer<Any> {
    val FILTERING = true

    val colormap = HEG.colorMap

    val function = { d: dynamic ->
        val ethnicName = d.properties.EthnicName as String
        val color = colormap.getColor(ethnicName)
        if(color != null) {
            arrayOf(color.r.toInt(), color.g.toInt(), color.b.toInt(), 127)
        } else {
            arrayOf(127, 127, 127, 127)
        }
//        if (ethnicName.startsWith("f"))
//            arrayOf(255, 127, 127, 127) else arrayOf(127, 127, 127, 127)
    }

    val heg = MVTLayer<Any>(unsafeJso {
        if(FILTERING) {
            id = "heg"
            this.data = "/martin/heg"
        } else {
            id = "heg-$year"
            this.data = "/martin/heg/${year}"
        }

        this.visible = visible

        this.pickable = true
        asDynamic().stroked = false
        asDynamic().filled = true
        asDynamic().extruded = false
        asDynamic().pointType = "circle"
//        lineWidthScale = 20
        asDynamic().lineWidthMinPixels = 1
        asDynamic().getFillColor = function
        asDynamic().getLineColor = { d : dynamic -> arrayOf(0,0,0, 127) }
        asDynamic().getPointRadius = 100
        asDynamic().getLineWidth = 1
        asDynamic().getElevation = 30

        if(FILTERING) {
            asDynamic().getFilterValue = { d: dynamic ->
                val from = (d.properties.From as? Number)?.toInt()
                val to = (d.properties.To as? Number)?.toInt()
                if (from != null && to != null && year >= from && year <= to) 1.0 else 0.0
            }
            asDynamic().filterRange = arrayOf(1.0, 1.0)
            updateTriggers = unsafeJso {
                this.asDynamic().getFilterValue = arrayOf(year)
            }

            extensions = arrayOf(DataFilterExtension(unsafeJso {
                filterSize = 1
            }))
        }
    })
    return heg
}

